module.exports = window["fs"];